import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import classes from "./andlayout.module.css";
import Footer from "../components/footer";
import data from "../utils/pagesData.json";
import useAuth from "../hooks/useAuth";

const ANDArenaLayout = ({ children }) => {
  const location = useLocation();
  const [activePath, setActivePath] = useState("");
  const navigate = useNavigate();
  const [isDesktop, setIsDesktop] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { isAuthenticated, user } = useAuth();

  const getLinkClass = (path) => {
    if (location.pathname.includes(path)) {
      return `${classes.navLink} ${classes.activeLink}`;
    }
    return classes.navLink;
  };

  const handleLogoClick = () => {
    navigate("/artist-next-door-arena");
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    setActivePath(location.pathname);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location]);

  useEffect(() => {
    const checkWindowSize = () => {
      if (typeof window !== "undefined") {
        setIsDesktop(window.innerWidth >= 768);
        if (window.innerWidth >= 768) {
          setMobileMenuOpen(false);
        }
      }
    };

    checkWindowSize();
    window.addEventListener("resize", checkWindowSize);

    return () => window.removeEventListener("resize", checkWindowSize);
  }, []);

  return (
    <div className={classes.container}>
      <header className={classes.header}>
        <div className={classes.logo} onClick={handleLogoClick}>
          <span>ArtistNextDoor</span>
          <span className={classes.logoSeparator}>x</span>
          <span className={classes.arenaText}>Arena</span>
        </div>

        {isDesktop ? (
          <nav className={classes.nav}>
            <Link
              to="/artist-next-door-arena/leaderboard"
              className={getLinkClass("/leaderboard")}
            >
              Leaderboards
            </Link>
            <Link
              to="/artist-next-door-arena/compete"
              className={getLinkClass("/compete")}
            >
              Compete Now
            </Link>
            <Link
              to="/artist-next-door-arena/vote-now"
              className={getLinkClass("/vote-now")}
            >
              Vote Now
            </Link>
            {!isAuthenticated ? (
              <Link to="/login" className={getLinkClass("/login")}>
                Login
              </Link>
            ) : (
              <Link
                to={`/dashboard/${user?.type === "artist" ? "artist" : "user"}`}
                className={getLinkClass("/login")}
              >
                {user?.username}
              </Link>
            )}
          </nav>
        ) : (
          <div className={classes.mobileNavControls}>
            <button
              className={classes.hamburgerButton}
              onClick={toggleMobileMenu}
              aria-label="Toggle menu"
            >
              <div
                className={`${classes.hamburgerLine} ${
                  mobileMenuOpen ? classes.line1Open : ""
                }`}
              ></div>
              <div
                className={`${classes.hamburgerLine} ${
                  mobileMenuOpen ? classes.line2Open : ""
                }`}
              ></div>
              <div
                className={`${classes.hamburgerLine} ${
                  mobileMenuOpen ? classes.line3Open : ""
                }`}
              ></div>
            </button>
          </div>
        )}
      </header>

      {/* Mobile menu overlay */}
      {!isDesktop && (
        <div
          className={`${classes.mobileMenu} ${
            mobileMenuOpen ? classes.mobileMenuOpen : ""
          }`}
        >
          <nav className={classes.mobileNav}>
            <Link
              to={`/dashboard/${user?.type === "artist" ? "artist" : "user"}`}
              className={getLinkClass("/login")}
            >
              {user?.username}
            </Link>
            <Link
              to="/artist-next-door-arena/leaderboard"
              className={getLinkClass("/leaderboard")}
              onClick={closeMobileMenu}
            >
              Leaderboards
            </Link>
            <Link
              to="/artist-next-door-arena/compete"
              className={getLinkClass("/compete")}
              onClick={closeMobileMenu}
            >
              Compete Now
            </Link>
            <Link
              to="/artist-next-door-arena/vote-now"
              className={getLinkClass("/vote-now")}
              onClick={closeMobileMenu}
            >
              Vote Now
            </Link>
          </nav>
        </div>
      )}

      <main className={classes.mainContent}>{children}</main>
      <Footer data={data} isDesktop={isDesktop} />
    </div>
  );
};

export default ANDArenaLayout;
